import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Truck } from "lucide-react";
import { MobileDrawerNav } from "@/components/layout/MobileDrawerNav";
import { SITE_MANAGER_SIDEBAR_NAV } from "@/config/navigation";

export function SiteManagerDrawerNav() {
  const navigate = useNavigate();

  const ctas = useMemo(
    () => [
      {
        icon: Truck,
        label: "Pré-commander",
        onClick: () => navigate("/site?reservation=true"),
        variant: "secondary" as const,
      },
      {
        icon: Plus,
        label: "Nouveau bétonnage",
        onClick: () => navigate("/site?nouveau=true"),
        variant: "default" as const,
      },
    ],
    [navigate],
  );

  return (
    <MobileDrawerNav
      navItems={SITE_MANAGER_SIDEBAR_NAV}
      ctas={ctas}
      settingsPath="/site/settings"
      showSiteSelector
    />
  );
}
